// extracted by mini-css-extract-plugin
module.exports = {"button":"styles_button__I077x","label":"styles_label__hyj66","icon":"styles_icon__8ZLO9"};